/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import * as fromStore from 'app/shared/store';
import { UserDataService } from 'app/shared/services/user-data.service';
import { GuardHelper } from 'app/shared/guards/guard-helper';

@Injectable()
export class LoggedInGuard implements CanActivate {
  constructor(
    private guardHelper: GuardHelper,
    private store: Store<fromStore.SharedState>,
    private userDataService: UserDataService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.guardHelper.checkStore().pipe(
      switchMap((ret) => {
        if (
          // if user goes to sign up with an invite then allow them to proceed
          (state.url.includes('register/signup') && route.queryParams.inviteId) ||
          // if user goes to sign up with an invite then allow them to proceed
          state.url.includes('register/confirmation') ||
          // if users goes to purchase page then allow them to proceed
          state.url.includes('register/checkout') ||
          // if user goes to email verification page then allow them to proceed
          state.url.includes('login/verify-email') ||
          // if user goes to login with a login as token the allow to proceed
          state.url.includes('login?lt')
        ) {
          return of(true);
        }
        this.router.navigate(['/']);
        return of(true);
      }),
      catchError((err) => {
        return of(true);
      })
    );
  }
}
